import { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { MessageRole } from '../hooks';
import { SpecialistPickerProps } from '../SpecialistPicker';
import { ChatMessage } from '../types';
import { AiAnswer } from './AiAnswer';
import { UserPrompt } from './UserPrompt';
import { LoadingState, MessageList } from './styles';

export interface MessagesProps {
  messages: ChatMessage[];
  isLoading: boolean;
  isSending: boolean;
  specialistPicker: SpecialistPickerProps;
  onEditPrompt: (content: string) => void;
}

export const Messages: FC<MessagesProps> = ({
  messages,
  isLoading,
  isSending,
  specialistPicker,
  onEditPrompt
}) => {
  if (isLoading && messages.length === 0) {
    return (
      <LoadingState>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} />} />
      </LoadingState>
    );
  }

  return (
    <MessageList>
      {messages.map((message, index) =>
        message.role === MessageRole.USER ? (
          <UserPrompt
            key={index}
            content={message.content}
            canEdit={!isSending}
            specialistPicker={specialistPicker}
            onEdit={onEditPrompt}
          />
        ) : (
          <AiAnswer
            key={index}
            content={message.content}
            threadId={message.threadId}
            messageId={message.messageId}
            animate={message.animate}
            pending={message.pending}
            isError={message.isError}
          />
        )
      )}
    </MessageList>
  );
};
